import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import {
  HTTP_AP_ListPreCompletions_ForTable_Request_Filter,
  HTTP_AP_ListPreCompletions_ForTable_Request_Sort,
} from '@api-new/mortgageservice';
import { PreCompletionTableRowModel } from '@platform/mortgage/models/pre-completion-table.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { AdjustedNetworkFilterModel } from '@shared/models/adjusted-network-filter.model';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const preCompletionTableFilterDefaults: AdjustedNetworkFilterModel<HTTP_AP_ListPreCompletions_ForTable_Request_Filter> = {
  primaryMortgageBorrowerDisplayNameOrEmail: '',
  networkIds: [],
  companyIds: [],
  advisorUserDisplayNameOrEmail: '',
  loanAmount: { min: null, max: null },
  ltv: { min: null, max: null },
  preCompletionStatus: null,
};

export const preCompletionTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<PreCompletionTableRowModel, HTTP_AP_ListPreCompletions_ForTable_Request_Sort>[] => [
  {
    columnLabel: 'Client name',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'primaryMortgageBorrowerDisplayName',
    isFrozen: true,
  },
  {
    columnLabel: 'Property Address',
    type: RowDefinitionTypeEnum.Address,
    columnKey: 'addressLines',
  },
  {
    columnLabel: 'Company',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'companyTradingName',
    isHidden: hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.ClientUserRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
  },
  {
    columnLabel: 'Assigned to',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'advisorUserDisplayName',
    isHidden: hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.ClientUserRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
      },
    ]),
  },
  {
    columnLabel: 'Loan amount',
    columnKey: 'loanAmount',
    type: RowDefinitionTypeEnum.Currency,
  },
  {
    columnLabel: 'LTV',
    columnKey: 'ltv',
    type: RowDefinitionTypeEnum.Percent,
  },
  {
    columnLabel: 'Product Detail',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'productNameHeadline',
  },
  {
    columnLabel: 'Offer Date',
    columnKey: 'offerDate',
    type: RowDefinitionTypeEnum.Date,
  },
  {
    columnLabel: 'Offer Expiry Date',
    columnKey: 'offerExpiryDate',
    type: RowDefinitionTypeEnum.Date,
  },
  {
    columnLabel: 'Pre-completion status',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'preCompletionStatus',
  },
];
